import { createContext, useContext, useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInAnonymously,
} from "firebase/auth";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import {
  authErrors,
  error,
  genStudentID,
  getMonth,
  getYear,
  success,
} from "../functions";
import { auth, db } from "../variables/values";
import $ from "jquery";

const AuthContext = createContext({
  login: () => {},
  sign: ({ email, password, first, surname, students, other }) => {},
  logged: "not",
});

export const useAuthCtx = () => useContext(AuthContext);

export const AuthContextProvider = ({ children }) => {
  const [logged, setLogged] = useState("not");

  useEffect(() => {
    login();
    return () => {};
  }, [logged === "not"]);

  const login = () => {
    signInAnonymously(auth)
      .then((userCredential) => {
        console.log(userCredential.user.uid);
        setLogged("logged");
      })
      .catch((error) => {
        const errorMessage = error.message;
        console.log(errorMessage);
      });
  };

  const sign = ({ email, password, first, surname, students, other }) => {
    let working = $.confirm({
      title: "",
      content: "Please Wait",
      icon: "fa fa-spinner fa-spin",
      closeAnimation: "scale",
      theme: "supervan",
      animation: "scale",
      type: "orange",
      draggable: false,
      buttons: {
        ok: {
          isHidden: true,
        },
        cancel: {
          isHidden: true,
        },
      },
      onOpen: function () {
        createUserWithEmailAndPassword(auth, email, password)
          .then(async (userCredential) => {
            const user = userCredential.user;
            setDoc(doc(db, "users", user.uid), {
              first: first,
              email: email,
              surname: surname,
              uid: user.uid,
              other: other,
              application: {
                submitted: false,
                pending: false,
                approved: {},
                declined: {},
                isApproved: false,
                isDeclined: false,
                submittedOn: serverTimestamp(),
              },
              reference: {
                submitted: false,
                pending: false,
                approved: {},
                declined: {},
                isApproved: false,
                isDeclined: false,
                submittedOn: serverTimestamp(),
              },
              year: getYear(),
              month: getMonth(),
              role: "student",
              studentID: genStudentID(students),
              datetime: serverTimestamp(),
              courses: [],
            })
              .then(() => {
                working.close();
                let suc = success(
                  "Sign up was successful, <strong>Redirecting to portal</strong>"
                );
                setTimeout(() => {
                  suc.close();
                  window.location.href = "https://smeproje.web.app";
                }, 1000);
              })
              .catch((e) => {
                working.close();
                error("Error", e.message);
              });
          })
          .catch((err) => {
            working.close();
            const e = authErrors({ err: err.code });
            error(e.code, e.message);
          });
      },
    });
  };

  const context = {
    login: login,
    sign: sign,
    logged: logged,
  };

  return (
    <AuthContext.Provider value={context}>{children}</AuthContext.Provider>
  );
};

export default AuthContext;
